import { FormControl } from '@angular/forms';

export enum GuaranteeStatus {
	DRAFT = 'Draft',
	OPEN = 'Open',
	LAUNCH_ANALYSIS = 'Launch analysis',
	SATISFIED = 'Satisfied',
	CERTIFICATE_REQUESTED = 'Certificate requested',
	CERTIFICATE_ISSUED = 'Certificate issued',
	REJECTED_BY_SUPLIER = 'Rejected by supplier',
	CANCELLED = 'Cancelled',
}

export interface PartForm {
	number: FormControl<number>;
	name: FormControl<string>;
	sheetThickness: FormControl<string>;
	magnelisCoatingMass: FormControl<string>;
	corrosion: FormControl<string>;
	fabricationProcess: FormControl<string>;
	epassivationEasyfilm: FormControl<string>;
}

/**
 * Category tag stored on a guarantee attachment (client-side only, held in
 * GuaranteeRequestAttachment.metaData.type). The backend keeps all files in a
 * single bucket; this tag drives per-document requirements and summary
 * grouping in the guarantee wizard.
 */
export const ATTACHMENT_CATEGORY_OTHER = 'Other';
export const ATTACHMENT_CATEGORY_SOIL = 'SoilAnalysis';
export const ATTACHMENT_CATEGORY_WATER = 'WaterAnalysis';
export const ATTACHMENT_CATEGORY_WEBFORM = 'webform';

export type AttachmentCategory =
	| typeof ATTACHMENT_CATEGORY_OTHER
	| typeof ATTACHMENT_CATEGORY_SOIL
	| typeof ATTACHMENT_CATEGORY_WATER;
